import { SellerEmployees } from 'components/sellers/SellerEmployees/SellerEmployees'

export const ProfileEmployees: React.FC = () => {
  return <SellerEmployees />
}
